import {
  conversion_game_hub_first_purchase_by_date_7,
  hub_visit_data_7,
  new_users_data_7,
  payment_count_and_payment_users_data_7,
  payments_success_fail_by_dates_7,
  revenue_by_date_device_7,
  revenue_by_dates_7,
  sales_by_date_7,
  triggers_by_date_7,
} from '@/layouts/dashboard/demo_data/data_7'
import dayjs from 'dayjs'
import { CategoryData, DateData } from '@/layouts/dashboard/demo_data/types'
import {
  conversion_game_hub_first_purchase_by_date_30,
  hub_visit_data_30,
  new_users_data_30,
  payment_count_and_payment_users_data_30,
  payments_success_fail_by_dates_30,
  revenue_by_date_device_30,
  revenue_by_dates_30,
  sales_by_date_30,
  triggers_by_date_30,
} from '@/layouts/dashboard/demo_data/data_30'

function moveDates(dates: DateData[] | CategoryData[], startIndex = 0) {
  dates = dates.reverse()
  dates.forEach((date, index) => {
    if ((date as DateData).date) {
      let dd = date as DateData
      dd.date = dayjs()
        .add(-index - startIndex, 'day')
        .format('YYYY-MM-DD')
    }
    if ((date as CategoryData).category) {
      let cd = date as CategoryData
      cd.category = dayjs()
        .add(-index - startIndex, 'day')
        .format('YYYY-MM-DD')
    }
  })

  return dates.reverse()
}

function moveDates3(dates: DateData[] | CategoryData[], startIndex = 0) {
  let index = startIndex
  dates = dates.reverse()
  for (let i = 0; i < dates.length; i++) {
    let date = dates[i]
    if ((date as DateData).date) {
      let dd = date as DateData
      dd.date = dayjs().add(-index, 'day').format('YYYY-MM-DD')
    }
    if ((date as CategoryData).category) {
      let cd = date as CategoryData
      cd.category = dayjs().add(-index, 'day').format('YYYY-MM-DD')
    }

    if (i % 3 == 0 && i != 0) {
      index++
    }
  }

  return dates.reverse()
}

export const makeRevenueByDatesDemoData = (filter: string) => {
  let data = filter == '7' ? revenue_by_dates_7 : revenue_by_dates_30
  data = data.map(it => ({
    ...it,
  }))
  moveDates(data)
  return data
}

export const makeBestTriggersByDatesDemoData = (filter: string) => {
  let data = filter == '7' ? triggers_by_date_7 : triggers_by_date_30
  data = JSON.parse(JSON.stringify(data))
  moveDates3(data.data)
  return data
}

export const makeHubVisitByDatesDemoData = (filter: string) => {
  let data = filter == '7' ? hub_visit_data_7 : hub_visit_data_30
  data = JSON.parse(JSON.stringify(data))
  moveDates(data)
  return data
}

export const makSalesDemoData = (filter: string) => {
  let data = filter == '7' ? sales_by_date_7 : sales_by_date_30
  data = JSON.parse(JSON.stringify(data))
  moveDates(data)
  return data
}

export const makeTopMeasuresDemoData = (filter: string) => {
  if (filter == '7') {
    return {
      arppu: { value: 2300, prev_value: 2000 },
      dau: { value: 8347.0, prev_value: 3883.0 },
      mau: { value: 145620.0, prev_value: 77716.0 },
      conversion: { value: 11.23, prev_value: 9.02 },
      total_usd_revenue: { value: 7542877.232595, prev_value: 4426514.45105 },
    }
  }

  return {
    arppu: { value: 2600, prev_value: 1500 },
    dau: { value: 8347.0, prev_value: 3883.0 },
    mau: { value: 145620.0, prev_value: 77716.0 },
    conversion: { value: 11.43, prev_value: 9.52 },
    total_usd_revenue: { value: 28667578.883865, prev_value: 21657214.71199 },
  }
}

export const makeNewUsersDemoData = (filter: string) => {
  let data = filter == '7' ? new_users_data_7 : new_users_data_30
  data = JSON.parse(JSON.stringify(data))
  moveDates(data)
  return data
}

export const makePaymentCountByDatesDemoData = (filter: string) => {
  let data = filter == '7' ? payment_count_and_payment_users_data_7 : payment_count_and_payment_users_data_30
  data = JSON.parse(JSON.stringify(data))
  moveDates(data)
  return data
}

export const makePaymentCountDemoData = (filter: string) => {
  return filter == '7'
    ? {
        value: 3560,
        prev_value: 1230,
      }
    : {
        value: 7560,
        prev_value: 4230,
      }
}

export const makePaymentSFDemoData = (filter: string) => {
  let data = filter == '7' ? payments_success_fail_by_dates_7 : payments_success_fail_by_dates_30
  data = data.map(it => ({
    ...it,
  }))
  moveDates(data)
  return data
}

export const makeConversionDemoData = (filter: string) => {
  let data =
    filter == '7' ? conversion_game_hub_first_purchase_by_date_7 : conversion_game_hub_first_purchase_by_date_30
  data = JSON.parse(JSON.stringify(data))
  moveDates(data.data)
  moveDates(data.prev_data, parseInt(filter))
  return data
}

export const makeRevenueByDeviceDatesDemoData = (filter: string) => {
  let data = filter == '7' ? revenue_by_date_device_7 : revenue_by_date_device_30
  data = JSON.parse(JSON.stringify(data))
  moveDates(data)
  return data
}
